<template>
    <div class="ah-page project-edit-page">
        <div class="page-header bottom-margin" id="invoice-edit-page-header">
            <div class="ah-container">
                <div class="title-row">
                    <div class="title">
                        <h1 v-if="!form.sno">新增財務收支</h1>
                        <h1 v-if="form.sno">編輯財務收支</h1>
                    </div>
                    <div class="actions"></div>
                </div>
            </div>
        </div>
        <div class="ah-container">
            <div class="ah-panel">
                <div class="panel-body">
                    <el-form ref="form" :model="form" :rules="rules" :label-position="isMobile() ? 'top' : 'right'" label-width="180px" v-loading="isLoading">
                        <el-form-item prop="type" label="類型">
                            <el-radio-group v-model="form.type" size="large" @change="onTypeChange" :disabled="!isAdd">
                                <el-radio-button v-if="urlType == 'income'" :label="1">
                                    營業其他收入
                                    <ah-tip>非營業交易產生的收入（例：利息）</ah-tip>
                                </el-radio-button>
                                <el-radio-button v-if="urlType == 'income'" :label="5">
                                    財務資產收入
                                    <ah-tip>例：保證金、預收貨款</ah-tip>
                                </el-radio-button>
                                <el-radio-button v-if="urlType == 'payout'" :label="2">
                                    營業其他支出
                                    <ah-tip>非營業交易產生的支出（例：利息）</ah-tip>
                                </el-radio-button>
                                <el-radio-button v-if="urlType == 'payout'" :label="6">
                                    財務資產支出
                                    <ah-tip>例：保證金、預付貨款</ah-tip>
                                </el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item prop="tpc" label="摘要">
                            <el-input v-model="form.tpc" style="max-width: 700px"></el-input>
                        </el-form-item>
                        <el-form-item prop="bnK_SNO" label="銀行帳戶">
                            <ah-el-select-bank-account v-model="form.bnK_SNO" document-type="variable-statement" @change="handleBankChange"></ah-el-select-bank-account>
                        </el-form-item>
                        <el-form-item prop="paY_DAT" :label="form.flg == -1 ? '付款日期' : '收款日期'">
                            <el-date-picker v-model="form.paY_DAT" value-format="timestamp" type="date" placeholder="選擇日期"> </el-date-picker>
                        </el-form-item>
                        <el-form-item prop="amt" label="金額">
                            <money-input v-model="form.amt" :precision="form.cny == 'TWD' ? 0 : 2" style="width: 200px; margin-right: 5px" />
                            <el-select v-model="form.cny" prop="cny" style="width: 100px" :disabled="true" no-data-text="無資料">
                                <el-option :label="item.cnynam" :value="item.cny" v-for="item in currencyList" :key="item.sno"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item prop="iteM_SNO">
                            <template v-slot:label>
                                {{ form.flg == -1 ? "支出項目" : "收入項目" }}
                            </template>
                            <div class="block">
                                <ahSelectVariableStateItem v-model="form.iteM_SNO" :enableType="[statementType]" @onLoaded="onVaribleStateSelectorLoaded" />
                            </div>
                        </el-form-item>
                        <el-form-item prop="mem" label="備註" :rules="form.sno != null ? rules_alt.mem : [{ required: false }]">
                            <el-input type="textarea" v-model="form.mem" :autosize="{ minRows: 5, maxRows: 15 }"></el-input>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <center>
                <el-button type="primary" class="primary-action" @click="handleSubmit" :loading="isSubmitting">送出</el-button>
            </center>
        </div>
    </div>
</template>
<script>
import ahElSelectBankAccount from '@/components/ui/ahElSelectBankAccount.vue';
import ahSelectVariableStateItem from '@/components/ui/ahSelectVariableStateItem.vue';

export default {
    components: {
        ahElSelectBankAccount,
        ahSelectVariableStateItem,
    },
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        inputObject: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            isLoading: false,
            isSubmitting: false,
            statementType: '',
            form: {
                type: 0, // 1:營業其他收入, 2:營業其他支出, 5: 財務資產收入, 6:財務資產支出
                sno: null,
                flg: this.$route.query.type === 'payout' ? -1 : 1,
                bnK_SNO: null,
                paY_DAT: new Date().getTime(),
                iteM_SNO: null,
                cny: 'TWD',
                amt: null,
                tpc: null,
                mem: null,
            },
            rules: {
                tpc: [
                    {
                        required: true,
                        message: '請填寫摘要',
                        trigger: 'blur',
                    },
                ],
                bnK_SNO: [
                    {
                        required: true,
                        message: '請選擇銀行帳戶',
                        trigger: 'change',
                    },
                ],
                paY_DAT: [
                    {
                        required: true,
                        message: '請選擇日期',
                        trigger: 'change',
                    },
                ],
                iteM_SNO: [
                    {
                        required: true,
                        message: '請選擇項目',
                        trigger: 'change',
                    },
                ],
                amt: [
                    {
                        required: true,
                        message: '請輸入金額',
                        trigger: 'blur',
                    },
                ],
            },
            rules_alt: {
                mem: [
                    {
                        required: true,
                        message: '修改請填寫修改原因於備註',
                        trigger: 'blur',
                    },
                ],
            },
            yearList: [],
        };
    },
    computed: {
        isAdd() {
            return this.form.sno === null;
        },
        currencyList() {
            return this.$store.getters['cny/cnyOptions'];
        },
        urlType() {
            if (this.$route.query.type) {
                return this.$route.query.type;
            }
            if (this.form.type) {
                if (this.form.type === 1 || this.form.type === 5) {
                    return 'income';
                }
                if (this.form.type === 2 || this.form.type === 6) {
                    return 'payout';
                }
            }
            return 'payout';
        },
    },
    created() {
        if (this.$route.params.sno) {
            this.fetchExistsData(this.$route.params.sno);
        } else {
            this.updateFormType();
            this.updateStatementByType();
        }
    },
    methods: {
        fetchExistsData(sno) {
            this.isLoading = true;
            this.$api({
                url: `/Tool/GetStatementForm?SNO=${sno}`,
                method: 'GET',
            })
                .then((resp) => {
                    this.form = resp.data.item;
                    // this.updateFormType();
                    this.updateStatementByType(false);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        onVaribleStateSelectorLoaded() {
            // force update value
            const sno = this.form.iteM_SNO;
            this.form.iteM_SNO = null;
            setTimeout(() => {
                this.form.iteM_SNO = sno;
            }, 2);
        },

        handleBankChange(bank) {
            // 變更銀行帳戶：同時變更對應的幣別
            this.form.cny = bank.cny;
        },

        handleSubmit() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.isSubmitting = true;
                    this.$api({
                        url: 'VariableStatementSettingPage/UpsertStatementForm',
                        method: 'POST',
                        data: this.form,
                    })
                        .then(() => {
                            this.$router.push({ name: 'variable-statement' });
                        })
                        .finally(() => {
                            this.isSubmitting = false;
                        });
                } else {
                    this.scrollViewToError();
                }
            });
        },

        onTypeChange() {
            this.updateStatementByType();
        },

        updateFormType() {
            if (this.urlType === 'payout') this.form.type = 6;
            if (this.urlType === 'income') this.form.type = 5;
        },

        updateStatementByType(resetItemSno = true) {
            this.statementType = this.getTypeNameByNum(this.form.type);
            if (resetItemSno) this.form.iteM_SNO = null;
        },

        getTypeNameByNum() {
            // "營業其他收入"
            if (this.form.type === 1) return 'cIn';
            // "營業其他支出"
            if (this.form.type === 2) return 'cOut';
            // "財務資產收入"
            if (this.form.type === 5) return 'cInElse';
            // "財務資產支出"
            if (this.form.type === 6) return 'cOutElse';
            return null;
        },

        scrollViewToError() {
            setTimeout(() => {
                const isError = document.getElementsByClassName('is-error');
                if (isError.length > 0) {
                    isError[0].scrollIntoView({
                        block: 'center',
                        behavior: 'smooth',
                    });
                }
            }, 100);
        },
    },
};
</script>
